import { gql } from "@apollo/client";

export const GET_GALLERY = gql`
  query GetGallery($galleryId: String!) {
    gallery(galleryId: $galleryId)
      @rest(type: "Gallery", path: "public/{args.galleryId}/feed") {
      data @type(name: "GalleryData") {
        posts @type(name: "GalleryPost") {
          data @type(name: "GalleryPostData") {
            displayThumbnailUrl
            thumbnailUrl
            redirectUrl
          }
        }
      }
      profile_picture_url
      username
    }
  }
`;

export interface GalleryPost {
  data: {
    displayThumbnailUrl?: string | null;
    thumbnailUrl: string;
    redirectUrl?: string | null;
  };
}

export interface Gallery {
  data: { posts: GalleryPost[] } | null;
  profile_picture_url: string | null;
  username: string | null;
}

export interface GetGalleryData {
  gallery: Gallery | null;
}

export interface GetGalleryVariables {
  galleryId: string;
}
